import { CSSProperties } from 'react';
import styled from '@emotion/styled';
import { semantic_colors, text_styles } from '../../foundation';
import { buildCSSWithLength, CSSValueWithLength, getAutoColorCode } from '../../styles';
import { TextButton, Stack } from '../../components';

export const TopBar = {
  Container: styled.div<{ backgroundColor?: CSSProperties['backgroundColor']; height?: CSSValueWithLength }>`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding-left: 16px;
    padding-right: 8px;
    ${({ height }) => buildCSSWithLength('height', height ?? 42)};
    background-color: ${({ backgroundColor }) => backgroundColor ?? semantic_colors.background.surface_inverse};
  `,
  Title: styled.a`
    display: flex;
    align-items: center;
  `,
  ActionArea: styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    padding: 0px;
  `,
  ActionButton: styled(TextButton)`
    display: flex;
    align-items: center;
    position: relative;
    color: ${semantic_colors.content.primary_inverse};
    &:hover {
      color: ${getAutoColorCode(semantic_colors.content.primary_inverse).hover};
      background-color: ${getAutoColorCode(semantic_colors.background.surface_inverse).hover};
    }
    &:active {
      color: ${getAutoColorCode(semantic_colors.content.primary_inverse).pressed};
      background-color: ${getAutoColorCode(semantic_colors.background.surface_inverse).pressed};
    }
  `,
  ActionIconButton: styled.span`
    position: relative;
    display: flex;
    align-items: center;
    position: relative;
    cursor: pointer;
    padding: 8px;
    border-radius: 4px;
    color: ${semantic_colors.content.primary_inverse};
    &:hover {
      color: ${getAutoColorCode(semantic_colors.content.primary_inverse).hover};
      background-color: ${getAutoColorCode(semantic_colors.background.surface_inverse).hover};
    }
    &:active {
      color: ${getAutoColorCode(semantic_colors.content.primary_inverse).pressed};
      background-color: ${getAutoColorCode(semantic_colors.background.surface_inverse).pressed};
    }
    & + & {
      margin-left: 1px;
    }
  `,
  NumberIcon: styled(Stack)<{ size?: 'large' | 'medium'; value: number }>`
    position: absolute;
    border-radius: ${({ value }) => (value > 9 ? '75px' : '50%')};
    align-items: center;
    justify-content: center;
    z-index: 1;
    pointer-events: none;
    background-color: ${semantic_colors.brand.primary};
    color: ${semantic_colors.content.primary_inverse};
    ${({ size, value }) =>
      size === 'large'
        ? `
        padding: 0 4px;
        height: 18px;
        ${value <= 9 ? 'width: 18px;' : ''}
        top: 1px;
        left: 27px;
        transform: translateX(-50%);
        ${text_styles.Caption_11_SemiBold};
      `
        : `
        padding: 2px 3px;
        height: 13px;
        ${value <= 9 ? 'width: 13px;' : ''}
        top: 4px;
        left: 22px;
        transform: translateX(-50%);
        ${text_styles.Caption_10_SemiBold};
      `}
  `,
};
